export type OwnerBasedStatus =
  | 'all'
  | 'draft-or-hold'
  | 'publish-scheduled'
  | 'published'
  | 'signed'
  | 'expired'
  | 'expire-soon'
  | 'cancelled'
  | 'cancelled-by-signer-mfa-error'
  | 'rejected'
  | 'removed'

export type SignerBasedStatus = 'pending' | 'approved-by-me' | 'rejected-by-me'

export type EnvelopeStatusFilter = OwnerBasedStatus | SignerBasedStatus

export const ENVELOPE_STATUS_FILTERS = [
  'all',
  'draft-or-hold',
  'publish-scheduled',
  'published',
  'signed',
  'expired',
  'expire-soon',
  'cancelled',
  'cancelled-by-signer-mfa-error',
  'rejected',
  'removed',
  'pending',
  'approved-by-me',
  'rejected-by-me',
] as const satisfies ReadonlyArray<EnvelopeStatusFilter>

export function isEnvelopeStatusFilter(
  value: unknown,
): value is EnvelopeStatusFilter {
  return (ENVELOPE_STATUS_FILTERS as ReadonlyArray<unknown>).includes(value)
}

export const SIGNER_BASED_STATUSES: Array<SignerBasedStatus> = [
  'pending',
  'approved-by-me',
  'rejected-by-me',
]

export function isSignerBasedStatus(
  status: EnvelopeStatusFilter,
): status is SignerBasedStatus {
  return SIGNER_BASED_STATUSES.includes(status as SignerBasedStatus)
}
